import React from 'react'
export default function TermsandConditionAgreementsPage(){
     return(
        <div className='text-left m-auto md:mt-8 w-full md:w-[580px] lg:w-[780px]'>
        <h2 className='mb-4 text-lg structure__main__subttl'>Terms and Conditions</h2>
        <p className='text-sm mb-12'>
         <b>1. Purchases</b><br/><br/>

          If you wish to purchase any product or service made available through the service, you may be asked about product including your purchase withoy limitation at info@devcookbooks.com.<br/><br/>

         {/* <b>2. Subscriptions</b><br/><br/>

          Some parts of the services are billed on a subscription basis. You will be billed in advance on a recurring date.<br/><br/> */}

         <b>2. Price</b><br/><br/>

          {/* Price is decided by based on average price of market.<br/><br/> */}
          Price is considered by consumed time to complete writing codes.<br/><br/>

         <b>3. Cancellation</b><br/><br/>

         (a) When customer is not sartisfied for our product or mistakenly ordered our product, customer has right to get refund. Customer can refund from button at billing menu. Refund will be applicable within 24hrs after purchase.<br/><br/>

         (b) If there are any system error or bug is found for the code and function is not working propery, we will refund after investigation of the bug. Customer contact to info@devcookbooks.com.<br/><br/>

         <b>4. Content</b><br/><br/>
          (a) Product codes are written by us and all products right is on us.<br/><br/>

          (b) When customer want to utilise our codes in business usage, you need to understand structure of the codes first, rearrange value, styles, structure, and rewrite codes in your styles.<br/><br/>

          (c) If you are using our codes to learn how it works, try write our codes and start rearange your styles with your own way. Tha helps you to be a better developer in professional business field.<br/><br/>

         <b>5. License to use our product</b><br/><br/>

         Our service allows you to post, link, store, share and otherwise make available certain information, text, graphics, videos, or other material.</p>


         </div>
     )
}